"use strict";

$(document).ready(function () {
  bindNewsListing();
  bindComebackStories();
});
function bindNewsListing() {
  var newsListingContainer = document.querySelector('#news-listing-container');
  if (!newsListingContainer) {
    return;
  }
  var btn = document.querySelector('#news-listing-more');
  if (!btn) {
    return;
  }
  var $btn = $(btn);
  var contextItemId = $btn.data("context-item-id");
  var page = $btn.data("page");
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    var apiUrl = "/api/sitecore/news/getnewslisting?Page=" + page + "&ContextItemId=" + contextItemId;
    makeRequest(apiUrl, "POST", null, null, function (xhttp, isNetworkSuccess) {
      if (isNetworkSuccess) {
        $btn.parent().remove();
        var $container = $(newsListingContainer);
        $container.append(xhttp.responseText);
        bindNewsListing();
      }
    });
  });
}
function bindComebackStories() {
  var comebackContainer = document.querySelector('.comeback-container');
  if (!comebackContainer) {
    return;
  }
  var dnDropdown = document.querySelector('#dnDropdown');
  if (!dnDropdown) {
    return;
  }
  var hdnContextItem = document.querySelector('#hdn-context-id');
  if (!hdnContextItem) {
    return;
  }
  var hdnDatasource = document.querySelector('#hdn-datasource-id');
  if (!hdnDatasource) {
    return;
  }
  var contextItemId = document.querySelector('#hdn-context-id');
  dnDropdown.addEventListener("change", function (e) {
    e.preventDefault();
    var apiUrl = "/api/sitecore/news/getcomebackstories?ContextItemId=" + hdnContextItem.value + "&DatasourceId=" + hdnDatasource.value;
    if (this.value != "") {
      apiUrl += "&DeliveryNetwork=" + this.value;
    }
    makeRequest(apiUrl, "POST", null, null, function (xhttp, isNetworkSuccess) {
      if (isNetworkSuccess) {
        var $container = $(comebackContainer);
        $container.html(xhttp.responseText);
        bindComebackStories();
      }
    });
  });
}